import { render, staticRenderFns } from "./CustomHeaderBanner.vue?vue&type=template&id=2d8ded86&scoped=true&"
import script from "./CustomHeaderBanner.vue?vue&type=script&lang=js&"
export * from "./CustomHeaderBanner.vue?vue&type=script&lang=js&"
import style0 from "./CustomHeaderBanner.vue?vue&type=style&index=0&id=2d8ded86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8ded86",
  null
  
)

export default component.exports